/** Organization roles a membership (or invitation) can carry. Mirrors the backend `OrgRole`. */
export const ORG_ROLES = [
  {
    value: "admin",
    label: "Admin",
    description: "Manage members, groups and organization settings.",
  },
  {
    value: "member",
    label: "Member",
    description: "Access the organization's tenants and collections.",
  },
  {
    value: "crm_reader",
    label: "CRM reader",
    description: "Read CRM data via Vayken CRM (reporting on calls, email, LinkedIn and funnels).",
  },
  {
    value: "deal_user",
    label: "Deal user",
    description: "See the deal engine's judgements of the deals they own.",
  },
  {
    value: "deal_manager",
    label: "Deal manager",
    description: "See their own and their reports' deals; approve CRM changes.",
  },
  {
    value: "deal_admin",
    label: "Deal admin",
    description: "See every deal, own the deal engine's rules, approve CRM changes.",
  },
] as const;

export type OrgRole = (typeof ORG_ROLES)[number]["value"];

export function orgRoleLabel(role: string): string {
  return ORG_ROLES.find((r) => r.value === role)?.label ?? role;
}
